import React from "react";
import Aux from '../../atom/children';
import MarginForm from '../../atom/formMargin';
import Label from '../../atom/label/label';
import DateF from '../../atom/DOB/dob';
import Error from '../../atom/error';



const Reactselect = (props) => {
    const onBlur = (e) => {
        //const { name, value } = e.currentTarget;
        props.onBlur(props.name, props.value)
    }
    const changeDOB = (e) => {

        props.onChange(props.name, e.formattedValue)
    }
    return (
        <Aux>
            <MarginForm margin={props.margin}>
                <Label label={props.label} />
                <div className="formRe">
                    <DateF
                        name={props.name}
                        id={props.name}
                        value={props.value}
                        onBlur={onBlur}
                        onChange={changeDOB}
                        class={props.class}
                    />
                    {props.icon ? <span className="icon_calender"></span> : null}
                    <Error errorMessage={props.errorMSg} />
                    {props.children}

                </div>
            </MarginForm>
        </Aux>
    );
};

export default Reactselect
